import { ReactNode } from 'react';

interface AppLayoutProps {
  sidebar: ReactNode;
  children: ReactNode;
  mobileHeader?: ReactNode;
}

export default function AppLayout({ sidebar, children, mobileHeader }: AppLayoutProps) {
  return (
    <div className="mt-6 min-h-screen bg-white sm:mt-0">
      <div className="mx-auto h-full max-w-screen-2xl px-[24px] lg:px-8">
        <div className="flex h-full flex-col lg:flex-row">
          <aside className="lg:pt-[24px] hidden w-[300px] shrink-0 pr-[25px] lg:block">{sidebar}</aside>
          <main className="flex-1 pb-16 pt-[64px] lg:border-l lg:border-[#0D0D0D1A] lg:px-[74px] lg:pt-[44px] max-w-[1160px]">
            {mobileHeader ? <div className="lg:hidden">{mobileHeader}</div> : null}
            <div className={'pt-[30px] md:pt-0'}>
              {children}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
